import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { registerUser } from "../../services/authService";
import { validateRegister } from "../../hooks/useFormValidation";
import { getFirebaseError } from "../../utils/firebaseErrors";
import logoTitle from "../../assets/images/Logos/kole-medical-wordmark.svg";
import "../../styles/AuthStyles/Register.css";
import visibilityOn from "../../assets/images/icons/visibility_60dp_024498_FILL1_wght400_GRAD0_opsz48.png";
import visibilityOff from "../../assets/images/icons/visibility_off_60dp_00000_FILL1_wght400_GRAD0_opsz48.png";

interface RegisterProps {
  onSwitch: () => void;
  className?: string;
}

export default function Register({ onSwitch, className }: RegisterProps) {

    const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [firebaseError, setFirebaseError] = useState("");
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [showPassword, setShowPassword]        = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: ""
  });

  const set = (key: string, value: string) => {
    setForm(prev => ({ ...prev, [key]: value }));
    setErrors(prev => ({ ...prev, [key]: "" })); // clear error on type
  };

  const handleRegister = async () => {
    setFirebaseError("");

    // 1. Run validation first
    const validationErrors = validateRegister(form);
    if (Object.keys(validationErrors).length) {
      setErrors(validationErrors);
      return;
    }

    // 2. Call Firebase
    try {
      setLoading(true);
      await registerUser(
        form.fullName,
        form.email,
        form.phone,
        form.password
      );
      navigate("/login"); // ✅ redirect after successful register
    } catch (error: any) {
      setFirebaseError(getFirebaseError(error.code));
    } finally {
      setLoading(false);
    }
  };

    return (
        <section className={`registationContainer ${className ?? ""}`}>
            {firebaseError && <p className="error-banner">{firebaseError}</p>}

            <div className="logoTitle">
                <img src={logoTitle} alt="Kole Medical" width={190} height={37} />
                <h3>Register</h3>
            </div>

            <input
              placeholder="Full Name"
              value={form.fullName}
              onChange={e => set("fullName", e.target.value)}
            />
            {errors.fullName && <p className="field-error">{errors.fullName}</p>}

            <input
              placeholder="Email"
              type="email"
              value={form.email}
              onChange={e => set("email", e.target.value)}
            />
            {errors.email && <p className="field-error">{errors.email}</p>}

            <input
              placeholder="+27 64 540 6751"
              type="tel"
              value={form.phone}
              onChange={e => set("phone", e.target.value)}
            />
            {errors.phone && <p className="field-error">{errors.phone}</p>}

            <div className="input-password-wrapper">
              <input
                placeholder="Password"
                type={showPassword ? "text" : "password"}
                value={form.password}
                onChange={e => set("password", e.target.value)}
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(prev => !prev)}
              >
                {showPassword ? (
                  <img src={visibilityOff} alt="Hide password" />
                ) : (
                  <img src={visibilityOn} alt="Show password" />
                )}
              </button>
              {errors.password && <p className="field-error">{errors.password}</p>}
            </div>

            {/* 3. Confirm Password field*/}
            <div className="input-password-wrapper">
              <input
                placeholder="Confirm Password"
                type={showConfirmPassword ? "text" : "password"}
                value={form.confirmPassword}
                onChange={e => set("confirmPassword", e.target.value)}
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowConfirmPassword(prev => !prev)}
              >
                {showConfirmPassword ? (
                  <img src={visibilityOff} alt="Hide password" />
                ) : (
                  <img src={visibilityOn} alt="Show password" />
                )}
              </button>
            </div>
            {errors.confirmPassword && <p className="field-error">{errors.confirmPassword}</p>}

            <div className="btnSection">
              <button onClick={handleRegister} disabled={loading}>
                {loading ? "Creating account..." : "Register"}
              </button>
              <button className="switchLink" onClick={onSwitch}>
                Already have an account? Login
              </button>
            </div>
        </section>
    );
};
